import { httpClient } from '../transports/http.js'  
import settings from '../../../public/settings.json'

export async function secondFactorLogin(params) {
  return (await httpClient.post('api/EAM.INSPECTIONS.GETTECH', params)).data
}

export async function getUserInfo() {
  return (await httpClient.post('api/EAM.QR.GETUSERINFO', {})).data
  // const data = (await httpClient.post('api/EAM.QR.GETUSERINFO', {})).data
  // debugger
  // if (data && data.UserId) {
  //   const user = data
  //   debugger
  //   if (user && user.Photo && user.Photo.length) {
  //     try {
  //       const photoUrl = `${settings.wsPath}GetFile.ashx?file=${user.Photo}&folder=content`
  //       const result = await fetch(photoUrl)
  //       debugger
  //       if (result.ok) {
  //         user.Photo = photoUrl
  //       }
  //       else {
  //         user.Photo = null
  //       }
  //     } catch (error) {
  //       user.Photo = null
  //     }
  //   }
  //   return user
  // }
  // return null
}